import { Flex } from 'onefaceui-react-components';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 600px;
  height: 100%;

  #mainSupervisorModalWrapper {
    .generic-modal__modal-body-container {
      padding: 0 !important;
    }

    .oneface-button,
    .oneface-icon-button {
      padding: 6px 16px !important;
      border-radius: 4px !important;
      font-weight: 600;
    }
  }

  .oneface-table {
    max-height: 370px;
  }
`;

export const ModalFooter = styled(Flex)`
  border-top: solid var(--grey-300) 1px;
  padding: 0.4rem;
`;
